import { render, staticRenderFns } from "./FeedbackListCard.vue?vue&type=template&id=7293b784&"
import script from "./FeedbackListCard.vue?vue&type=script&lang=js&"
export * from "./FeedbackListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports